<template>
  <div>

    <!-- 面包屑导航 -->
<!--    <el-page-header size="mini" @back="back" style="padding: 10px 0;" :content="title">-->
<!--    </el-page-header>-->
    <!-- 卡片 -->
    <el-card class="box-card">

      <el-form
          :inline="false"
          :model="addForm"
          ref="addForm"
          :rules="rules"
          autocomplete="on"
          size="mini"
          label-width="80px">

        <el-row :gutter="24">
          <el-col :span="6">
            <el-link type="primary" @click="back"><i class="el-icon-back"></i> 返回</el-link>
             |
<!--            <el-link href="/Welcome">首页</el-link>-->
<!--            >-->
<!--            <el-link type="primary" href="/extrasFeeList">费用列表</el-link>-->
<!--            > -->
            {{ title }}
          </el-col>
          <el-col :span="6">
            <el-form-item label="选择个人" label-width="80px" size="small" required>
              <span v-if="addForm.id">
                <el-select v-model="addForm.car_username" disabled placeholder="请选择个人或者填入名称">
                <el-option
                    v-for="item in carUserName"
                    :key="item.value"
                    :label="item.label"
                    :value="item.label">
                </el-option>
              </el-select>
              </span>
              <span v-else>
                <el-select v-model="addForm.car_username" clearable placeholder="请选择个人或者填入名称" filterable allow-create>
                <el-option
                    v-for="item in carUserName"
                    :key="item.value"
                    :label="item.label"
                    :value="item.label">
                </el-option>
              </el-select>
              </span>

            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="选择车辆" size="small">
              <el-select v-model="addForm.car_id" filterable clearable placeholder="请选择车牌">
                <el-option
                    v-for="item in carData"
                    :label="item.plate_number"
                    :value="item.id"
                    :key="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-button style="margin-bottom: 10px" size="small" type="primary" @click="setFeeData">
              添加费用明细
            </el-button>
          </el-col>


        </el-row>
        <el-row :gutter="24" v-if="addForm.id">
          <el-col :span="24">
            <el-descriptions title="各项费用统计" direction="vertical" :column="7" border size="mini">
              <el-descriptions-item label="车辆台次">
                {{ getShopFeeInfo.car_count }}
              </el-descriptions-item>
              <el-descriptions-item label="统计项目">
                {{ getShopFeeInfo.project_count }}
                个</el-descriptions-item>
              <el-descriptions-item label="应收">
                {{ getShopFeeInfo.ysfee_sum }}
              </el-descriptions-item>
              <el-descriptions-item label="成本">
                {{ getShopFeeInfo.cbfee_sum }}
              </el-descriptions-item>
              <el-descriptions-item label="利润">
                {{ getShopFeeInfo.lrfee_sum }}
              </el-descriptions-item>
              <el-descriptions-item label="已收">
                {{ getShopFeeInfo.yishoufee_sum }}
              </el-descriptions-item>
              <el-descriptions-item label="未收">
                {{ getShopFeeInfo.wsfee_sum }}
              </el-descriptions-item>
            </el-descriptions>
            <br />
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="24" align="left">

            <el-table
                :data="feeDataList"
                stripe border
                :header-cell-style="{background:'#e5e5e5',color:'#333333'}"
                show-summary
                height="450px"
                size="mini"
            >
              <el-table-column label="操作" align='center'>
                <template slot-scope="scope">
                  <el-button @click.native.prevent="deleteItem(scope.$index, scope.row)" type="danger" size="mini" icon="el-icon-delete" circle></el-button>
                </template>
              </el-table-column>
              <el-table-column label="个人" prop="car_username" :show-overflow-tooltip='true'>
              </el-table-column>
              <el-table-column
                  prop="name"
                  label="经办角色"
                  :show-overflow-tooltip='true'
              >
                <template slot-scope="scope">
                  <el-select v-model="scope.row.jbrTypeId" clearable placeholder="请选择经办人角色" filterable allow-create>
                    <el-option
                        v-for="item in jbrTypeList"
                        :key="item.id"
                        :label="item.title"
                        :value="item.id">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column
                  prop="name"
                  label="经办姓名"
                  :show-overflow-tooltip='true'
              >
                <template slot-scope="scope">
                  <el-select v-model="scope.row.jbrxmTypeId" clearable placeholder="请选择经办人姓名" filterable allow-create>
                    <el-option
                        v-for="item in jbrxmTypeList"
                        :key="item.id"
                        :label="item.title"
                        :value="item.id">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>

              <el-table-column label="车牌号" prop="plate_number" :show-overflow-tooltip='true'>
              </el-table-column>

              <el-table-column label="所属人" prop="allPerson" :show-overflow-tooltip='true'>
              </el-table-column>

              <el-table-column label="车架号" prop="vin" :show-overflow-tooltip='true'>
              </el-table-column>

              <el-table-column
                  prop="name"
                  label="费用类型"
                  :show-overflow-tooltip='true'

              >
                <template slot-scope="scope">
                  <el-select v-model="scope.row.fee_type" clearable placeholder="请选择费用类型" filterable allow-create>
                    <el-option
                        v-for="item in feeTypeList"
                        :key="item.id"
                        :label="item.title"
                        :value="item.id">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
<!--              <el-table-column label="费用名称" :show-overflow-tooltip='true'>-->
<!--                <template slot-scope="scope">-->

<!--                  <el-input v-model="scope.row.name" ></el-input>-->

<!--                </template>-->
<!--              </el-table-column>-->

              <el-table-column label="应收" prop="ysfee":show-overflow-tooltip='true'>
                <template slot-scope="scope">

                  <el-input v-model="scope.row.ysfee" @blur="changeYsPrice(scope.row)"></el-input>

                </template>
              </el-table-column>
              <el-table-column label="成本" prop="cbfee":show-overflow-tooltip='true'>
                <template slot-scope="scope">

                  <el-input v-model="scope.row.cbfee" @blur="changeYsPrice(scope.row)"></el-input>

                </template>
              </el-table-column>
              <el-table-column label="利润" prop="lrfee"  :show-overflow-tooltip='true'>
                <template slot-scope="scope">

                  <el-input v-model="scope.row.lrfee" ></el-input>

                </template>
              </el-table-column>
              <el-table-column label="已收" prop="yishoufee"  :show-overflow-tooltip='true'>
                <template slot-scope="scope">

                  <el-input v-model="scope.row.yishoufee" @blur="changeYsPrice(scope.row)"></el-input>

                </template>
              </el-table-column>
              <el-table-column label="未收" prop="wsfee" :show-overflow-tooltip='true'>
                <template slot-scope="scope">

                  <el-input v-model="scope.row.wsfee" ></el-input>

                </template>
              </el-table-column>
              <el-table-column label="备注" :show-overflow-tooltip='true'>
                <template slot-scope="scope">

                  <el-input type="textarea" v-model="scope.row.remark" :autosize="{ minRows: 2, maxRows: 3}"></el-input>

                </template>
              </el-table-column>

            </el-table>
          </el-col>
        </el-row>

      </el-form>
      <el-row :gutter="24" class="centerButton">
        <el-col :span="24">
        <el-button @click="resetForm">取 消</el-button>
        <el-button type="primary" @click="submitForm('addForm')">确 定</el-button>
        </el-col>
      </el-row>
    </el-card>
    <!-- 全局遮罩 图片上传 -->
    <el-dialog :visible.sync="dialogVisible" :modal="true" :close-on-click-modal="false" :close-on-press-escape="false" width="50%">
      <div class="loading-overlay">
        <div class="loading-spinner" style="font-size:30px;font-weight: bold">
          <i class="el-icon-upload"></i>
          图片上传ing
          <i class="el-icon-loading"></i>
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import moment from 'moment'     //日期时间转换
import imgCompressUtil from "../../utils/imgCompressUtil";
import carListTemp from "../common/carlistTemp.vue";


export default {
  name: "extrasFeeAdd",
  components: {carListTemp},
  data() {
    return {
      dialogVisible: false,
      overlayClass: 'loading-overlay', // 遮罩元素的类名
      addForm:{
        id:'',
        car_info:'',
        car_id:'',
        plate_number:'',
        allPerson:'',
        vin:'',
        car_username:'',
      },

      rules: {
        // plate_number: [{ required: true, message: '请输入号牌号码', trigger: 'blur' }],
        // allPerson: [{ required: true, message: '请输入所有人', trigger: 'blur' }],
        // shop_id: [{ required: true, message: '请选择运输公司', trigger: 'blur' }],
        // vin: [{ required: true, message: '请输入车辆识别代号', trigger: 'blur' }],
        car_username: [{ required: true, message: '请输入个人', trigger: 'blur' }],
      },
      title: '费用列表 - 新增',
      feeDataList:[
        // {
        //   'name':'费用名称',
        //   'fee_type':'1',
        //   'jbr_type':'1',
        //   'jbrxm_type':'1',
        //   'ysfee':'1666.88',
        //   'cbfee':'1000.88',
        //   'lrfee':'666.00',
        //   'yishoufee':'666.88',
        //   'wsfee':'1000.00',
        //   'remark':'备注',
        //   'car_id':'',
        //   'allPerson':'',
        //   'plate_number':'',
        //   'vin':'',
        //   'car_username':'李四'
        // },
        // {
        //   'name':'费用名称2',
        //   'fee_type':'1',
        //   'jbr_type':'1',
        //   'jbrxm_type':'1',
        //   'ysfee':'1666.88',
        //   'cbfee':'1000.88',
        //   'lrfee':'666.00',
        //   'yishoufee':'666.88',
        //   'wsfee':'1000.00',
        //   'remark':'备注',
        //   'car_id':'',
        //   'allPerson':'',
        //   'plate_number':'',
        //   'vin':'',
        //   'car_username':'李四'
        // },
        // {
        //   'name':'费用名称3',
        //   'fee_type':'1',
        //   'jbr_type':'1',
        //   'jbrxm_type':'1',
        //   'ysfee':'1666.88',
        //   'cbfee':'1000.88',
        //   'lrfee':'666.00',
        //   'yishoufee':'666.88',
        //   'wsfee':'1000.00',
        //   'remark':'备注',
        //   'car_id':'',
        //   'allPerson':'',
        //   'plate_number':'',
        //   'vin':'',
        //   'car_username':'李四'
        // },
      ],
      feeTypeList:[
        // {
        //   value: '1',
        //   label: '车辆年审费用'
        // },
        // {
        //   value: '2',
        //   label: '车辆管理费'
        // },
        // {
        //   value: '3',
        //   label: '营运证年审'
        // },
        // {
        //   value: '4',
        //   label: '驾驶证年审'
        // },
        // {
        //   value: '5',
        //   label: '二级维护'
        // },
        // {
        //   value: '6',
        //   label: '从业资格证年审'
        // },
        // {
        //   value: '7',
        //   label: '车辆等级评定费'
        // },
        // {
        //   value: '8',
        //   label: '其他费用'
        // },
      ],
      jbrTypeList:[
        // {
        //   value: '1',
        //   label: '超管'
        // },
        // {
        //   value: '2',
        //   label: '经理'
        // },
        // {
        //   value: '3',
        //   label: '财务'
        // },
        // {
        //   value: '4',
        //   label: '内勤'
        // },
        // {
        //   value: '5',
        //   label: '业务员'
        // }
      ],
      jbrxmTypeList:[
        // {
        //   value: '1',
        //   label: '张珊'
        // },
        // {
        //   value: '2',
        //   label: '李四'
        // }
      ],
      carUserName:[
        // {
        //   value: '1',
        //   label: '张珊'
        // },
        // {
        //   value: '2',
        //   label: '李四'
        // }
      ],
      innerVisible: false,
      carData:[], //车辆列表
      getShopFeeInfo: {}, //车辆列表
    };
  },
  created() {
    this.getCarData();
    var id = this.$route.query.id;

    if(id){
      this.title = '费用列表 - 编辑'
      this.addForm.id=id;
      this.DataList();

    }
    this.getShopFeeOptionList(1);
    this.getShopFeeOptionList(2);
    this.getShopFeeOptionList(3);
    this.getShopFeeOptionList(4);
  },
  mounted() {},
  filters: {

    //时间格式化
    dateFormat(add_time) {
      if (add_time == undefined) {
        return "";
      }
      return moment(add_time*1000).format("yyyy-MM-DD HH:mm:ss");
    },

  },
  methods: {
    back(){
      this.$router.back();
    },

    // 新增
    setFeeData() {
        let idCount = this.feeDataList.length+1;
      let item = {
        'id':idCount,
        'name':'',
        'fee_type':'',
        'jbr_type':'',
        'jbrxm_type':'',
        'ysfee':'',
        'cbfee':'',
        'lrfee':'',
        'yishoufee':'',
        'wsfee':'',
        'remark':'',
        'car_id':'',
        'allPerson':'',
        'plate_number':'',
        'vin':'',
        'car_username':''
      };
      if(this.addForm.car_id){
        const car_info = this.carData.find(item => item.id === this.addForm.car_id);

        item.car_id = car_info.id;
        item.allPerson = car_info.allPerson;
        item.plate_number = car_info.plate_number;
        item.vin = car_info.vin;
      }

      if(this.addForm.car_username){
        item.car_username = this.addForm.car_username;
      }else{
        this.$message.error('请先选择个人/或者填写');return false;
      }

      this.feeDataList.push(item);
      // console.log('add-feeDataList',this.feeDataList);
    },
    //删除数据
    deleteItem(index, row) {
      this.feeDataList.splice(index, 1);
      if(row.id){

          this.$confirm('此操作将删除该费用记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            const param = {
              company_id:sessionStorage.getItem('company_id'),
              access_token:sessionStorage.getItem('token'),
              id: row.id,
              type: 2,
            }
            //console.log(param);
            this.$axios.delFeeShopFee(param).then(res=>{
              if(res.code == 200){
                this.$message.success(res.msg);
                this.DataList()
              }else{
                this.$message.error(res.msg);
              }
            }).catch(error=>{
              //console.log(error);
            })
          }).catch(() => {
            // 点击取消:不删除了
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
            this.DataList()
          });
      }
      //删除接口
    },
    setcarInfo(value){


      if(value){
        this.addForm.plate_number = value.plate_number
        this.addForm.car_id = value.car_id
        this.addForm.vin = value.vin
        this.addForm.model = value.model
        this.addForm.issue_date = value.issue_date
        this.addForm.register_date = value.register_date
      }else{
        this.addForm = {};
      }

    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const param = {
            company_id:sessionStorage.getItem('company_id'),
            access_token:sessionStorage.getItem('token'),
            feeDataList:this.feeDataList,
          }
          if(this.$route.query.id) param.id = this.$route.query.id;

          this.$axios.feeShopSave(param).then(res =>{
            if(res.code == 200){
              if(this.$route.query.id){
                this.DataList();
                this.$router.push({path:'/extrasFeeAdd',query:{id:this.$route.query.id}})
              }else{
                this.$router.push({path:'/extrasFeeList'})
              }

              this.$message.success(res.msg);
              this.dialogFormVisible = false;
            }else{
              this.$message.error(res.msg);
            }
          })
        }
      })
    },
    resetForm(){
      this.addForm = {
        id:'',
        car_id:'',
        plate_number:'',
        allPerson:'',
        vin:'',
        car_username:'',
      };
    },
    getCarData() {
      const param = {
        company_id:sessionStorage.getItem('company_id'),
        access_token:sessionStorage.getItem('token'),
      }
      this.$axios.getCarList(param).then(res=>{
        if(res.code == 200){

          this.carData = res.data.data
        }else{
          this.$message.error(res.msg);
        }
      }).catch(error=>{
        //console.log(error);
      })
    },
    DataList() {
      const param = {
        company_id:sessionStorage.getItem('company_id'),
        access_token:sessionStorage.getItem('token'),
        fee_id:this.addForm.id,
      }
      this.$axios.getShopFeeInfo(param).then(res=>{
        if(res.code == 200){
          this.getShopFeeInfo = res.data;
          this.addForm.car_username = this.getShopFeeInfo.car_username;

          this.feeDataList = this.getShopFeeInfo.fee_list;
        }else{
          this.$message.error(res.msg);
        }
      }).catch(error=>{
        //console.log(error);
      })
    },
    getShopFeeOptionList(type) {
      const param = {
        company_id:sessionStorage.getItem('company_id'),
        access_token:sessionStorage.getItem('token'),
        type:type,
      }
      this.$axios.getShopFeeOptionList(param).then(res=>{
        if(res.code == 200){

          if(type == 1){
            this.jbrTypeList = res.data;
          }else if(type == 2){
            this.jbrxmTypeList = res.data;
          }else if(type == 3){
            this.feeTypeList = res.data;
          }else if(type == 4){
            this.carUserName = res.data;
          }else {
            this.$message.error(res.msg);
          }


        }else{
          this.$message.error(res.msg);
        }
      }).catch(error=>{
        //console.log(error);
      })
    },
    //计算利润和未收open
      changeYsPrice(row){
        //判断应收是否填写
          if(!row.ysfee){
              this.$message.error('请先填写应收费用');
              return false;
          }
          //如果填入了成本字段，则自动算出利润
          if(row.cbfee){
              //四舍五入对利润
              row.lrfee = Math.round(row.ysfee - row.cbfee);
          }

          if(row.yishoufee){
              row.wsfee = Math.round(row.ysfee - row.yishoufee);
          }
      },
      //计算利润和未收end
  },
};
</script>
<style scoped>
.centerButton{
  margin-top:20px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/view/fee/extrasFeeAdd.vue